import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  MonitorDependencyGraphDto,
  MonitorSettingsDto,
} from '@kortxio/hub-api';
import { MonitorSettingsDraftEdge } from 'features/admin-monitoring/dependencies/types';
import { reportApiError } from 'features/shared/reportApiError';
import api from 'libs/api';
import { toApiError } from 'libs/api/helper';
import { AsyncThunkConfig } from 'store/types';

export const getMonitorDependencies = createAsyncThunk<
  MonitorDependencyGraphDto,
  { monitorKey: string },
  AsyncThunkConfig
>(
  'monitoringDependencies/getMonitorDependencies',
  async ({ monitorKey }, { dispatch, rejectWithValue }) => {
    try {
      const response =
        await api.monitorDependency.getMonitorDependencies(monitorKey);

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);

export type SaveMonitorSettingsArgs = {
  monitorKey: string;
  enabled: boolean;
  cronExpression: string;
  dependencies: MonitorSettingsDraftEdge[];
};

export const saveMonitorSettings = createAsyncThunk<
  MonitorSettingsDto,
  SaveMonitorSettingsArgs,
  AsyncThunkConfig
>(
  'monitoringDependencies/saveMonitorSettings',
  async (
    { monitorKey, enabled, cronExpression, dependencies },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.monitor.updateMonitorSettings(monitorKey, {
        enabled,
        cronExpression,
        dependencies: dependencies.map((edge) => ({
          upstreamMonitorKey: edge.upstreamMonitorKey,
          onUpstreamFailing: edge.behavior,
          transitive: edge.transitive,
        })),
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(toApiError(error));
    }
  }
);
